import React from 'react'

import styled from 'styled-components'

import { Panel } from 'components/Panel'
import ColumnGridPanel from 'components/ColumnGridPanel'

import LastUpdated from 'pages/Device/LastUpdated'
import Zone from 'pages/Device/ZoneStatusPanel/Zone'

import { screenSize } from 'styles/shared'

import ZoneStatus from 'types/ZoneStatus'

import { color } from 'styles/colors'

type Props = {
  zones: ZoneStatus[]
  lastUpdatedAt?: string,
  airFlowPercentage: number
  outdoorTemperature: string
  hasAwairDevice: boolean
  deviceType: string
}

const ZoneStatusPanel = ({ airFlowPercentage, outdoorTemperature, hasAwairDevice = false, zones, lastUpdatedAt, deviceType }: Props) => (
  <S.Panel id="zone-status" scrollToSection>
    <Panel.Header>
      <Panel.Title>Zone Status</Panel.Title>
      <LastUpdated date={lastUpdatedAt ? new Date(lastUpdatedAt) : null} />
    </Panel.Header>

    <S.ColumnGridPanel>
      {
        zones.map(
          (zone) => (
            <Zone
              key={zone.id}
              zone={zone}
              deviceType={deviceType}
              airFlowPercentage={airFlowPercentage}
              outdoorTemperature={outdoorTemperature}
              hasAwairDevice={hasAwairDevice}
            />
          )
        )
      }
    </S.ColumnGridPanel>
  </S.Panel>
)

export default ZoneStatusPanel

const S = {
  ColumnGridPanel: styled(ColumnGridPanel)`
    grid-template-columns: repeat(auto-fill, minmax(250px, auto));

    @media ${screenSize.medium} {
      grid-template-columns: repeat(2, 1fr);
    }
    @media ${screenSize.small} {
      grid-template-columns: repeat(1, 1fr);
    }
  `,
  Panel: styled(Panel)`
    scroll-margin-top: 60px;
    background-color: ${color('paneBackground')};
  `
}
